import { useEffect, useState } from 'react';

/**
 * Tracks whether the viewport currently matches a mobile/touch-sized layout.
 * Defaults to the same 900px breakpoint the generator styles use so the
 * JS-driven behavior (fullscreen overlays, the on-screen generate button)
 * stays in sync with the CSS media queries.
 *
 * @param {string} query - the media query to watch.
 * @returns {boolean} true when the query matches.
 */
export function useIsMobile(query = '(max-width: 900px)') {
  const getMatch = () =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia(query).matches
      : false;

  const [isMobile, setIsMobile] = useState(getMatch);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mql = window.matchMedia(query);
    const onChange = e => setIsMobile(e.matches);
    setIsMobile(mql.matches);
    // addEventListener is the modern API; fall back for older Safari.
    if (mql.addEventListener) {
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    }
    mql.addListener(onChange);
    return () => mql.removeListener(onChange);
  }, [query]);

  return isMobile;
}

export default useIsMobile;
